const state = {
    strings : []
}
const mutations = {
    'SET_STRINGS' ( state, strings ) {
        state.strings = strings;
    }
};
const actions = {
    initStrings : ( {commit} ) => {
        commit( 'SET_STRINGS', labelVariables );
    }
};
const getters = {
    strings : state => {
        return state.strings;
    }
}
export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/globalStrings.js